import React from 'react';
import s from './Menu.scss';
import { useSettings } from '../../../../../providers/SettingsProvider';
import { useView, View } from '../../../../../providers/ViewProvider';
import { useGetPlaybackRateText } from '../SpeedSelector';
import { useTexts } from '../../../../../useTexts';
import classNames from 'classnames';
import { Arrow } from '../Arrow/Arrow';
const MenuItem = _ref => {
  let {
    title,
    value,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    className: s.button,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: s.title
  }, title), /*#__PURE__*/React.createElement("span", {
    className: s.value
  }, value), /*#__PURE__*/React.createElement(Arrow, null)));
};
export const Menu = _ref2 => {
  let {
    visible
  } = _ref2;
  const {
    playbackRate,
    config: {
      speedEnabled,
      onMenuClicked
    },
    qualityState
  } = useSettings();
  const {
    setView
  } = useView();
  const getPlaybackRateText = useGetPlaybackRateText();
  const {
    menuSpeedTitle,
    menuQualityTitle
  } = useTexts();
  const handleMenuClick = view => {
    setView(view);
    if (onMenuClicked) {
      onMenuClicked(view);
    }
  };
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames(s.list, {
      [s.visible]: visible
    })
  }, speedEnabled ? /*#__PURE__*/React.createElement(MenuItem, {
    title: menuSpeedTitle,
    value: getPlaybackRateText(playbackRate),
    onClick: () => handleMenuClick(View.Speed)
  }) : null, qualityState ? /*#__PURE__*/React.createElement(MenuItem, {
    title: menuQualityTitle,
    value: qualityState.selectedQuality.name,
    onClick: () => handleMenuClick(View.Quality)
  }) : null);
};
//# sourceMappingURL=Menu.js.map